'use client';

export default function LemonAffiliateScript() {
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: `
          <script>
            window.lemonSqueezyAffiliateConfig = { store: "brightthemes" };
          </script>
          <script src="https://lmsqueezy.com/affiliate.js" async></script>
        `
      }}
    />
  );
}